import { Box, Grid, GridItem, Heading } from '@chakra-ui/react';
import { InlineEditField } from './InlineEditField'
import type { ContactDetail } from '../../types/contactDetail'

interface ContactInfoSectionProps {
  contact: ContactDetail
  canEdit: boolean
  onFieldSave: (fieldName: string, value: string) => void
  isSaving?: boolean
}

export function ContactInfoSection({
  contact,
  canEdit,
  onFieldSave,
  isSaving,
}: ContactInfoSectionProps) {
  return (
    <Box bg="surface" p={6} borderRadius="lg" shadow="md">
      <Heading size="sm" mb={4}>Personal Information</Heading>
      <Grid templateColumns="repeat(3, 1fr)" gap={4}>
        <GridItem>
          <InlineEditField
            label="First Name" value={contact.firstName} fieldName="firstName"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Middle Name" value={contact.middleName} fieldName="middleName"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Last Name" value={contact.lastName} fieldName="lastName"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Nickname" value={contact.nickName} fieldName="nickName"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Date of Birth"
            value={contact.dateOfBirth ? new Date(contact.dateOfBirth).toLocaleDateString() : undefined}
            fieldName="dateOfBirth" canEdit={canEdit} onSave={onFieldSave}
            type="date" isSaving={isSaving}
          />
        </GridItem>
      </Grid>

      <Heading size="sm" mt={6} mb={4}>Address</Heading>
      <Grid templateColumns="repeat(3, 1fr)" gap={4}>
        <GridItem colSpan={2}>
          <InlineEditField
            label="Street Address" value={contact.streetAddress} fieldName="streetAddress"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Address Type" value={contact.addressType} fieldName="addressType"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="City" value={contact.city} fieldName="city"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="State" value={contact.state} fieldName="state"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="Zip" value={contact.zip} fieldName="zip"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
        <GridItem>
          <InlineEditField
            label="County" value={contact.county} fieldName="county"
            canEdit={canEdit} onSave={onFieldSave} isSaving={isSaving}
          />
        </GridItem>
      </Grid>
    </Box>
  )
}
